enum InventoryAllocationStrategyEnum {
    FIFO = "fifo",
    PRIORITY = "priority",
    FAIR_SHARE = "fair_share",
}

export default InventoryAllocationStrategyEnum;
